const container = document.querySelector('.js-sidebar')
const openButtons = document.querySelectorAll('.js-sidebar-open')
const closeButtons = document.querySelectorAll('.js-sidebar-close')

function open() {
  document.body.style.overflowY = 'hidden'
  container.classList.add('is-open')

  // Set to CSS transition duration.
  setTimeout(() => container.focus(), 300)
}

function close() {
  document.body.style.overflowY = ''
  container.classList.remove('is-open')
  openButtons[0].focus()
}

for (const button of openButtons) {
  button.addEventListener('click', open)
}

for (const button of closeButtons) {
  button.addEventListener('click', close)
}
